/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAdsMeasurementDto
 */
export interface UpdateAdsMeasurementDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAdsMeasurementDto
     */
    advertisingConsent: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateAdsMeasurementDto
     */
    consentVersion: UpdateAdsMeasurementDtoConsentVersionEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateAdsMeasurementDto
     */
    expectedGeneration: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAdsMeasurementDto
     */
    capturedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdsMeasurementDto
     */
    gclid?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdsMeasurementDto
     */
    gbraid?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdsMeasurementDto
     */
    wbraid?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdsMeasurementDto
     */
    fbc?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdsMeasurementDto
     */
    fbp?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdsMeasurementDto
     */
    clientUserAgent?: string;
}

/**
* @export
* @enum {string}
*/
export enum UpdateAdsMeasurementDtoConsentVersionEnum {
    NUMBER_2 = 2
}

export function UpdateAdsMeasurementDtoFromJSON(json: any): UpdateAdsMeasurementDto {
    return UpdateAdsMeasurementDtoFromJSONTyped(json, false);
}

export function UpdateAdsMeasurementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAdsMeasurementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'advertisingConsent': json['advertisingConsent'],
        'consentVersion': json['consentVersion'],
        'expectedGeneration': json['expectedGeneration'],
        'capturedAt': !exists(json, 'capturedAt') ? undefined : (new Date(json['capturedAt'])),
        'gclid': !exists(json, 'gclid') ? undefined : json['gclid'],
        'gbraid': !exists(json, 'gbraid') ? undefined : json['gbraid'],
        'wbraid': !exists(json, 'wbraid') ? undefined : json['wbraid'],
        'fbc': !exists(json, 'fbc') ? undefined : json['fbc'],
        'fbp': !exists(json, 'fbp') ? undefined : json['fbp'],
        'clientUserAgent': !exists(json, 'clientUserAgent') ? undefined : json['clientUserAgent'],
    };
}

export function UpdateAdsMeasurementDtoToJSON(value?: UpdateAdsMeasurementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'advertisingConsent': value.advertisingConsent,
        'consentVersion': value.consentVersion,
        'expectedGeneration': value.expectedGeneration,
        'capturedAt': value.capturedAt === undefined ? undefined : (value.capturedAt.toISOString()),
        'gclid': value.gclid,
        'gbraid': value.gbraid,
        'wbraid': value.wbraid,
        'fbc': value.fbc,
        'fbp': value.fbp,
        'clientUserAgent': value.clientUserAgent,
    };
}

